export default "__VITE_ASSET__185be441__"